import { withPluginApi } from "discourse/lib/plugin-api";

function initialize(api) {
  const currentUser = api.getCurrentUser();
  if (!currentUser?.admin) {
    return;
  }

  api.addAdminSidebarSectionLink("root", {
    name: "admin_manage_account",
    route: "manage-account",
    label: "admin.config.manage_account.title",
    icon: "credit-card",
  });

  api.addAdminSidebarSectionLink("root", {
    name: "admin_manage_updates",
    route: "manage-updates",
    label: "admin.config.manage_updates.title",
    icon: "arrows-rotate",
  });
}

export default {
  name: "admin-sidebar",
  initialize() {
    withPluginApi(initialize);
  },
};
